<template>
  <div :class="['month-row', `size-${size}`]">
    <div
      v-for="month in 12"
      :key="month"
      class="month-tile"
      :class="[
        recurringMonths.includes(month) ? 'color-' + month : 'inactive',
        month === 1 ? 'first' : '',
        month === 12 ? 'last' : '',
      ]"
    >
      {{ month }}
    </div>
    <span class="overlay-text" v-if="overlayText">{{ overlayText }}</span>
  </div>
</template>

<script>
export default {
  name: "MonthTiles",
  props: {
    recurringMonths: {
      type: Array,
      required: true,
    },
    overlayText: String,
    size: {
      type: String,
      default: "md", // 'sm' | 'md'
    },
  },
}
</script>

<style scoped>
.month-row {
  display: flex;
  flex-wrap: nowrap;
  max-width: fit-content;
  border-radius: 5px;
  border: 1px solid #6e6b7b;
  position: relative;
}

.month-row.size-sm {
  border-radius: 4px;
}

.month-row.size-sm .month-tile {
  width: 11.5px;
  height: 20px;
  font-size: 10px;
  font-weight: 600;
}

.month-row.size-sm .overlay-text {
  font-size: 10px;
  border-radius: 4px;
}

.overlay-text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  background: white;
  border-radius: 5px;
}

.month-tile {
  width: 14px;
  height: 24px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: black;
}

/* Rounded edges */
.month-tile.first {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.month-tile.last {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* Inactive months: white background */
.month-tile.inactive {
  background-color: white;
  color: white;
}

/* Colored backgrounds for each active month (mid-tone, high-contrast) */
.color-1 {
  background-color: #bbdefb;
} /* blue */
.color-2 {
  background-color: #64b5f6;
} /* brighter blue */
.color-3 {
  background-color: #90caf9;
} /* soft blue */
.color-4 {
  background-color: #c8e6c9;
} /* pale green */
.color-5 {
  background-color: #81c784;
} /* medium green */
.color-6 {
  background-color: #388e3c;
  color: white;
} /* dark green */
.color-7 {
  background-color: #fbc02d;
} /* amber */
.color-8 {
  background-color: #ffb74d;
} /* orange */
.color-9 {
  background-color: #ef6c00;
  color: white;
} /* dark orange */
.color-10 {
  background-color: #ce93d8;
} /* lavender */
.color-11 {
  background-color: #ab47bc;
  color: white;
} /* purple */
.color-12 {
  background-color: #6a1b9a;
  color: white;
} /* deep purple */
</style>
